import axios from "../axios";

/**
 * 4.1 登录
 * POST /as-web/api/v1/auth/login
 */
export const login = (data) => {
  return axios({
    //url: "auth/login",
    url: "auth/login",
    method: "post",
    data,
  });
};
